import { sizeTab, texto, a11yProps, hasPermission, ROUTER_PATHS } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import SolicitudOrdenCompraEnesperaPagina from "./ordenesCompraEnesperaPage/ordenesCompraEnesperaPage";
import SolicitudOrdenCompraRechazadasPagina from "./ordenesCompraRechazadasPage/ordenesCompraRechazadasPage";
import { PermissionsEnum } from "@/auth/interfaces";
import SolicitudOrdenCompraFinalizadaPagina from "./ordenesCompraFinalizadaPage/ordenesCompraFinalizadaPage";
import { useLocation, useNavigate } from "react-router-dom";
import SolicitudOrdenCompraParcialPagina from "./ordenesCompraParcialPage/ordenesCompraParcialPage";
import OdenesCompraAbiertoPage from "./ordenesCompraAbiertoPage/ordenesCompraAbiertoPage";

export default function OrdenComprasPagina() {
  //const returnUrl = '/compras/orden-compras';
  const navigate = useNavigate()
  const location = useLocation();
  const returnUrl = ROUTER_PATHS.compras.orden_compras_nav
  //const [valueTab, setValueTab] = useState(0);


  // Usa el tabIndex solo una vez
  const initialTabIndex = typeof location.state?.tabIndex === "number" ? location.state.tabIndex : 0;
  const [valueTab, setValueTab] = useState(initialTabIndex);

  // Limpiar tabIndex del state (opcional, pero recomendado para evitar que vuelva a afectar)
  useEffect(() => {
    if (location.state?.tabIndex !== undefined) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  return (

    <SingleTableBoxScene
      title={"Ordenes de Pedido"}
      urlRedirect={`${returnUrl}/crear`}
      enableRedirect={hasPermission(PermissionsEnum.api_add_ordencompra)}
    >

      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs solicitud pedidos"
        >
          <Tab label={texto.ordenes_espera} {...a11yProps(0)} />
          <Tab label={texto.ordenes_abierta} {...a11yProps(1)} />
          <Tab label={texto.ordenes_parcial} {...a11yProps(2)} />
          <Tab label={texto.ordenes_rechazada} {...a11yProps(3)} />
          <Tab label={texto.ordenes_finalizada} {...a11yProps(4)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <SolicitudOrdenCompraEnesperaPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <OdenesCompraAbiertoPage />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <SolicitudOrdenCompraParcialPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={3}>
        <SolicitudOrdenCompraRechazadasPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={4}>
        <SolicitudOrdenCompraFinalizadaPagina />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );

}


